// ============================================
// API CONFIGURATION - Auto-detect environment
// ============================================
// Frontend React app: http://localhost:3000 (set via PORT env var or .env)
// Backend API server: http://localhost:8001
// 
// Environment variable priority:
// 1. REACT_APP_API_URL (explicitly set)
// 2. Auto-detect based on hostname
const getApiBaseUrl = () => {
  // If REACT_APP_API_URL is explicitly set, use it
  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL;
    console.log('🔧 Using explicit REACT_APP_API_URL:', url);
    return url;
  }

  // Auto-detect based on current origin
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || 
                      hostname === '127.0.0.1' ||
                      hostname === '' ||
                      hostname.startsWith('192.168.') ||
                      hostname.startsWith('10.') ||
                      hostname.startsWith('172.');

  if (isLocalhost) {
    // Local development
    const url = 'http://localhost:8001';
    console.log('🏠 Local development detected, using:', url);
    return url;
  } else {
    // Production - use production backend domain
    const url = 'https://ocb.senew-tech.com';
    console.log('🌐 Production detected, using:', url);
    return url;
  }
};

const API_BASE_URL = getApiBaseUrl();
console.log('📡 API Base URL configured:', API_BASE_URL);

// Helper function for API calls with error handling
async function apiCall(endpoint, options = {}) {
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Request failed' }));
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    // Handle 204 No Content
    if (response.status === 204) {
      return null;
    }

    return await response.json();
  } catch (error) {
    // Network errors or other fetch failures
    throw new Error(error.message || 'Network error');
  }
}

// Player API
export async function getPlayers() {
  return apiCall('/players');
}

export async function getPlayerById(id) {
  return apiCall(`/players/${id}`);
}

export async function createPlayer(name) {
  return apiCall('/players', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });
}

export async function updatePlayer(id, name) {
  return apiCall(`/players/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ name }),
  });
}

export async function deletePlayer(id) {
  return apiCall(`/players/${id}`, {
    method: 'DELETE',
  });
}

// Session API
export async function getTonightSession() {
  return apiCall('/session/tonight');
}

export async function saveTonightSession(tonightPlayerIds) {
  // Ensure tonightPlayerIds is an array
  if (!Array.isArray(tonightPlayerIds)) {
    console.error('saveTonightSession: tonightPlayerIds is not an array:', tonightPlayerIds);
    throw new Error('tonightPlayerIds must be an array');
  }
  
  const payload = { tonightPlayerIds };
  console.log('saveTonightSession: Sending payload:', payload);
  
  return apiCall('/session/tonight', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function resetSession() {
  return apiCall('/session/reset', {
    method: 'POST',
  });
}
